import FlavourTabs from 'components/tiled-menu/FlavourTabs'
import React from 'react'
import { useSelector } from 'react-redux'
import selectPageParameters from 'redux/selectors/selectPageParameters'

const Header = () => {
  const params = useSelector(selectPageParameters)
  const flavours = params?.flavours ?? []

  return flavours.length > 1 && <FlavourTabs flavours={flavours} />
}

export default Header
